module.exports=[
  {
    "id": "49391",
    "date": "3/10/2020",
    "state": "WA",
    "party": "Dem",
    "office": "P",
    "results": []
  }
]